import { motion } from 'framer-motion';

const puffs = Array.from({ length: 18 }, (_, i) => ({ id: i, x: Math.random() * 100, y: Math.random() * 100, s: 60 + Math.random() * 160, d: 8 + Math.random() * 10, delay: Math.random() * -12 }));

export function LoadingScreen({ progress }) {
  return (
    <motion.div className="fixed inset-0 z-[60] flex items-center justify-center overflow-hidden" style={{ background: '#061a3d' }}
      exit={{ opacity: 0, filter: 'blur(12px)' }} transition={{ duration: 1.2, ease: 'easeInOut' }} data-testid="loading-screen">
      {puffs.map((p) => (
        <motion.div key={p.id} className="absolute rounded-full" style={{ left: `${p.x}%`, top: `${p.y}%`, width: p.s, height: p.s * 0.6, background: 'radial-gradient(ellipse, rgba(255,255,255,0.14), rgba(255,255,255,0) 70%)', filter: 'blur(6px)' }}
          animate={{ x: [0, 140, 260], opacity: [0, 1, 0] }} transition={{ duration: p.d, delay: p.delay, repeat: Infinity, ease: 'linear' }} />
      ))}
      <div className="relative px-8 text-left">
        <p className="cloud-eyebrow mb-4" data-testid="loading-brand">StorySpark Studios</p>
        <h1 className="cloud-text text-3xl sm:text-5xl lg:text-6xl" data-testid="loading-title">
          BUILDING THE<br />ATMOSPHERE<motion.span animate={{ opacity: [0, 1, 0] }} transition={{ duration: 1.4, repeat: Infinity }}>...</motion.span>
        </h1>
        <div className="mt-10 h-px w-64 sm:w-96 bg-white/15 overflow-hidden rounded-full">
          <motion.div className="h-full" style={{ background: 'linear-gradient(90deg, #f97316, #ffb37a)', boxShadow: '0 0 18px rgba(249,115,22,0.8)' }} animate={{ width: `${Math.round(progress * 100)}%` }} transition={{ ease: 'easeOut', duration: 0.6 }} data-testid="loading-progress" />
        </div>
        <p className="mt-3 text-xs tracking-[0.3em] text-white/50 font-display">{Math.round(progress * 100)}% · ALTITUDE 14,000 FT</p>
      </div>
    </motion.div>
  );
}
